import {MyopMessages} from "../../common/MyopMessages";
import {
    AddEventListenerMessage,
    EventListenerCallbackMessage,
} from "../../messages";
import {BaseWebComponentMessageHandler, MessageToHost} from "./BaseWebComponentMessageHandler.ts";
import {ShadowRootRef} from "../shadowRootRef.ts";
import {getElementsByRef} from "../../common/messageHandlers/helpers";
import {makeSerializable} from "../../common/utils/serialization.ts";

export class AddEventListenerHandler extends BaseWebComponentMessageHandler<AddEventListenerMessage> {

    messageType = MyopMessages.AddEventListenerMessage;

    innerExecutor = (event: AddEventListenerMessage, shadowRootRef: ShadowRootRef, messageToHost: MessageToHost) => {

        const items = getElementsByRef(event.ref, shadowRootRef.shadowRoot);
        const cleanupTasks: (() => void)[] = [];

        items.forEach(item => {
            const handler = (e) => {
                // in fact when running in WebComponent we can transfer the original e
                // currently using makeSerializable for nested cases, think about that
                messageToHost(new EventListenerCallbackMessage(event.handlerUniqueId,  makeSerializable(e, event.serializableSkeleton)));
            };

            item.addEventListener(event.type, handler);

            cleanupTasks.push(() => {
                item.removeEventListener(event.type, handler);
            })
        });

        return () => {
            cleanupTasks.forEach(task => task())
        }
    }
}
